import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-3368">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-3369">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-3370" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-3371" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-3372">
        <div className="flex gap-8" data-id="element-3373">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-3374">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-3375" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3376">
        <div className="space-y-6" data-id="element-3377">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3378">
            <div data-id="element-3379">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-3380" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-3381" />
            </div>
            <div data-id="element-3382">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-3383" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-3384" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-3385">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-3386" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-3387" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3388">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-3389">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-3390" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-3391" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-3392">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-3393" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-3394" />
      </div>
    </div>;
}